module.exports = __webpack_public_path__ + "e8b6f06ce411b10ac5f855007584a1bc.svg";